/**
 * Proyecto: MOGOTAX-SERVER
 * Autor: Megatrack GPS SAS
 * Fecha de creación: 11 de noviembre 2024
 * Licencia: Propiedad Privada
 *
 * Este código es propiedad exclusiva de Megatrack GPS SAS & Mogotax SAS y no puede ser distribuido, copiado, modificado, publicado, sublicenciado ni comercializado sin el consentimiento expreso y por escrito de ambas empresa.
 *
 * Copyright (c) 2025 Megatrack GPS SAS. Todos los derechos reservados.
 */
import axios from "axios";

const ORS_API_KEY = "5b3ce3597851110001cf62482fd42f5bd98f4bada3f602a3fcc425fd";

export const getRoute = async (origin, destination) => {
  const url =
    "https://api.openrouteservice.org/v2/directions/driving-car/geojson";

  const headers = {
    Authorization: ORS_API_KEY,
    "Content-Type": "application/json",
  };

  const data = {
    coordinates: [
      [origin.longitude, origin.latitude],
      [destination.longitude, destination.latitude],
    ],
  };

  try {
    const response = await axios.post(url, data, { headers });
    return response.data;
  } catch (error) {
    console.error("Error al obtener la ruta:", error);
    return null;
  }
};
